// Logica pura del aviso de oferta nueva del portal (PP-64, llevado a todo el
// portal en PP-71): cuando una vuelta de la encuesta de ofertas tiene que
// sonar y que ofertas cuentan, segun las habilitaciones y el filtro de planta
// global. Sin React ni reloj (regla de frontend).
import type { ProviderMultiSiteTrip } from "@ucorp/contracts";
import type { SiteAccess } from "../sites/port.js";
import { freshOffers, liveOfferKeys, rowsInScope } from "./home.js";
import { accessesForSite } from "./navigation.js";

export interface OfferAlertStep {
  /** Ofertas vistas hasta esta vuelta, incluida. */
  readonly seen: ReadonlySet<string>;
  /** Si esta vuelta suena. */
  readonly ring: boolean;
}

/**
 * Una vuelta de la encuesta. `all` son las ofertas de todas las habilitaciones
 * de la cuenta: se recuerdan aunque el filtro las oculte, asi cambiar de
 * planta no hace sonar lo que ya estaba. Solo suenan las de `scoped` (las del
 * filtro): un operador que mira una planta no oye las de otra.
 *
 * Sin `seen` (la primera vuelta: abrir o recargar) no suena nada. Las vistas
 * se acumulan: una oferta que falta en una vuelta y vuelve no suena dos veces.
 */
export function offerAlertStep(
  seen: ReadonlySet<string> | undefined,
  all: readonly ProviderMultiSiteTrip[],
  scoped: readonly ProviderMultiSiteTrip[],
): OfferAlertStep {
  const fresh = freshOffers(seen, all);
  const next = new Set([...(seen ?? []), ...liveOfferKeys(all)]);
  const inScope = new Set(liveOfferKeys(scoped));
  return { seen: next, ring: fresh.some((key) => inScope.has(key)) };
}

export interface OffersInScope {
  /** Las de todas las habilitaciones de la cuenta (las que se recuerdan). */
  readonly all: ProviderMultiSiteTrip[];
  /** Las del filtro de planta (las que suenan y cuentan en el titulo). */
  readonly scoped: ProviderMultiSiteTrip[];
}

/** Las ofertas de la encuesta contra las habilitaciones y el filtro global (`null` es "Todas"). */
export function offersInScope(items: readonly ProviderMultiSiteTrip[], sites: readonly SiteAccess[], siteId: string | null): OffersInScope {
  const all = rowsInScope(items, sites);
  return { all, scoped: siteId === null ? all : rowsInScope(all, accessesForSite(sites, siteId)) };
}

